<template>
  <modal :title="`${title} ${$t('integration.details')}`"
     :visible.sync="isShowDialog" width="1300px" @close="close">
    <!-- 总体信息的table -->
    <div class="border">
      <div class="bg-theme color-white"
       style="width: 100%;text-align:center; height:30px;line-height:30px;">
       {{ $t('public.total_info') }}
      </div>
       <div class="uk-flex uk-flex-between pd-10">
        <div class="btns">
          <el-button :type="type === 1 ? 'primary' : ''"
            :disabled="dataType !== 1"
             @click="changeType(1)">{{ $t('integration.day') }}</el-button>
          <el-button :type="type === 2 ? 'primary' : ''" @click="changeType(2)">{{ $t('integration.month') }}</el-button>
          <el-button :type="type === 3 ? 'primary' : ''" @click="changeType(3)">{{ $t('integration.quarter') }}</el-button>
          <el-button :type="type === 4 ? 'primary' : ''" @click="changeType(4)">{{ $t('integration.year') }}</el-button>

        </div>
        <div style="flex:1;">
          <!-- 直接统计显示饼图 -->
          <pieEchart v-if="dataType ===1 && overallList.length" :chartData="setPieEchartData()"/>
          <!-- 同比和环比显示柱状图 -->
          <BarEchart v-if="dataType !== 1 && computedDataList.length" :chartData="setBarEchartDataOverall()"/>
        </div>
        <div style="width:45%">
          <div class="mb-5">
            <el-radio-group v-model="dataType" @change="changeDataType">
            <el-radio :label="1">{{ $t('integration.direct_statistics') }}</el-radio>
            <el-radio :label="2"
              :disabled="type === 1">
              {{ $t('integration.year_on_year') }}{{ $t('integration.data') }}
            </el-radio>
            <el-radio :label="3"
              :disabled="type === 1">
              {{ $t('integration.month_on_month') }}{{ $t('integration.data') }}
            </el-radio>
          </el-radio-group>
          </div>
          <div class="mb-10">
            <!-- 直接统计时右边table的显示 -->
            <div v-if="dataType === 1">
              <template v-if="type === 1">
                <el-date-picker
                  v-model="timeParams.day"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width:100%;"
                  :clearable="false"
                  @change="changeTime">
                </el-date-picker>
              </template>
              <template v-else-if="type === 2">
                <el-date-picker
                  v-model="timeParams.month"
                  type="month"
                  :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                  value-format="yyyy-MM"
                  style="width:100%;"
                  :clearable="false"
                  @change="changeTime">
                </el-date-picker>
              </template>
              <template v-else-if="type === 3">
                <div>
                  <el-select v-model="timeParams.quarterYear" style="width:40%;" class="mr-5" @change="changeTime">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="timeParams.quarter" style="width:55%;" @change="changeTime">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-else>
                <el-select v-model="timeParams.year" style="width:100%;" @change="changeTime">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </template>
              <div class="border mt-10" style="max-height:100px; overflow: auto;">
                <template v-if="overallList.length">
                  <el-row v-for="(item,index) in overallList" :key="index">
                    <el-col :span="8" class="bd-r">{{ abnormalTypeConvert(item.exCatalog) }}</el-col>
                    <el-col :span="16">{{ exType === 'num' ? item.num : formatSeconds(item.time / 1000)}}</el-col>
                  </el-row>
                  <!-- 异常最高温/湿度和最低温/湿度-->
                  <template v-if="overallMaxMin">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_max_temp_hum') }}</el-col>
                      <el-col :span="16">
                        <span v-if="overallMaxMin.tempMax">{{ formatTempValue(overallMaxMin.tempMax) }}{{tempUnit}}</span>
                        <span v-if="overallMaxMin.tempMax && overallMaxMin.humMax"> / </span>
                        <span v-if="overallMaxMin.humMax">{{ overallMaxMin.humMax}}%RH</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_min_temp_hum') }}</el-col>
                      <el-col :span="16">
                        <span v-if="overallMaxMin.tempMin">{{ formatTempValue(overallMaxMin.tempMin)}}{{tempUnit}}</span>
                        <span v-if="overallMaxMin.tempMin && overallMaxMin.humMin"> / </span>
                        <span v-if="overallMaxMin.humMin">{{ overallMaxMin.humMin}}%RH</span>
                      </el-col>
                    </el-row>
                    <!-- 温度/湿度异常持续时间 -->
                    <el-row v-if="exType === 'time'">
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_temp') }}</el-col>
                      <el-col :span="16" v-if="overallMaxMin.tempTimeMax">{{ formatSeconds(overallMaxMin.tempTimeMax / 1000)}}</el-col>
                    </el-row>
                    <el-row v-if="exType === 'time'">
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_hum') }}</el-col>
                      <el-col :span="16" v-if="overallMaxMin.humTimeMax">{{ formatSeconds(overallMaxMin.humTimeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                  <!-- 异常次数里面的离线持续最长时间-->
                  <template v-if="exType === 'time' && offlineMax">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_offline') }}</el-col>
                      <el-col :span="16" v-if="offlineMax.timeMax">{{ formatSeconds(offlineMax.timeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                  <!-- 异常次数里面的断电持续最长时间-->
                  <template v-if="exType === 'time' && powerMax">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_power') }}</el-col>
                      <el-col :span="16" v-if="offlineMax.timeMax">{{ formatSeconds(offlineMax.timeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                </template>
                <el-empty v-else :description="$t('public.no_data')" :image-size="50"></el-empty>
              </div>
            </div>
            <div v-else>
              <!-- 同比数据时 -->
              <div v-if="dataType === 2">
                <!-- 月：同比 -->
                <template v-if="type === 2">
                  <div>{{$t('integration.statistics')}}
                    <el-date-picker
                      v-model="timeParams.month"
                      type="month"
                      :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                      value-format="yyyy-MM"
                      style="width:80%;"
                      :clearable="false"
                      @change="changeTimeComputed">
                    </el-date-picker>
                  </div>
                  <div class="mt-5">{{$t('integration.year_on_year')}}
                    <el-select v-model="computedParams.computedYear" style="width:65%;" @change="changeTimeComputedYear">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    {{ computedParams.computedMonth }} {{$t('integration.month')}}
                  </div>
                </template>
                <!-- 季度：同比 -->
                <template v-else-if="type === 3">
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                      </el-option>
                    </el-select>
                    <el-select v-model="timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                      <el-option
                        v-for="item in quarterList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.year_on_year')}}
                    <el-select v-model="computedParams.computedQuarterYear" style="width:30%;" @change="changeTimeComputedYear">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.value === timeParams.quarterYear">
                      </el-option>
                    </el-select>
                    {{ computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                  </div>
                </template>

                <!-- 年：同比 -->
                <template v-else>
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="timeParams.year" style="width:80%;" @change="changeTimeComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.year_on_year')}}
                    {{ computedParams.computedYear }} {{$t('integration.year')}}
                  </div>
                </template>

              </div>

              <!-- 环比数据时 -->
              <div v-else>
                <!-- 月：环比 -->
                <template v-if="type === 2">
                  <div>{{$t('integration.statistics')}}
                    <el-date-picker
                      v-model="timeParams.month"
                      type="month"
                      :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                      value-format="yyyy-MM"
                      style="width:80%;"
                      :clearable="false"
                      @change="changeTimeComputed">
                    </el-date-picker>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ computedParams.computedYear }} {{$t('integration.year')}}
                    {{ computedParams.computedMonth }} {{$t('integration.month')}}
                  </div>
                </template>
                <!-- 季度：环比 -->
                <template v-else-if="type === 3">
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                      </el-option>
                    </el-select>
                    <el-select v-model="timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                      <el-option
                        v-for="item in quarterList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ computedParams.computedQuarterYear }} {{$t('integration.year')}}
                  {{ computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                  </div>
                </template>
                <!-- 年：环比 -->
                  <template v-else>
                    <div>{{$t('integration.statistics')}}
                      <el-select v-model="timeParams.year" style="width:80%;" @change="changeTimeComputed">
                        <el-option
                          v-for="item in yearList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="mt-5">{{$t('integration.month_on_month')}}
                      {{ computedParams.computedYear }} {{$t('integration.year')}}
                    </div>
                  </template>
              </div>

              <div style="height:140px; overflow: auto;">
                <el-table
                  :data="computedDataList"
                  :key="isUpdate"
                  border
                  ref="computedTable"
                  style="margin-top:10px;"
                >
                  <el-table-column
                    :label="$t('public.exception')"
                    >
                    <template  slot-scope="scope">
                      <span>{{ abnormalTypeConvert(scope.row.exCatalog) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index) in computedDynamicColumns"
                    :key="index"
                    width="180"
                  >
                    <template slot="header">
                      <span>{{ item }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="exType === 'num'">
                        <span v-if="!scope.row.countList[index] || !scope.row.countList[index].num"> - </span>
                        <span v-else>
                          {{ scope.row.countList[index].num }}
                        </span>
                      </template>
                      <template v-else>
                        <span v-if="!scope.row.countList[index] || !scope.row.countList[index].time"> - </span>
                        <span v-else>
                          {{ formatSeconds(scope.row.countList[index].time / 1000) }}
                        </span>
                      </template>
                    </template>
                  </el-table-column>

                  <div slot="append">
                    <div v-if="computedDataMaxMin">
                      <div class="uk-flex uk-flex-between">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_max_temp_hum') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].tempMax">{{formatTempValue(computedDataMaxMin.countList[0].tempMax)}}{{tempUnit}}</span>
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].tempMax && computedDataMaxMin.countList[0].humMax"> / </span>
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].humMax">{{ computedDataMaxMin.countList[0].humMax}}%RH</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].tempMax">{{ formatTempValue(computedDataMaxMin.countList[1].tempMax)}}{{tempUnit}}</span>
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].tempMax && computedDataMaxMin.countList[1].humMax"> / </span>
                          <span v-if="computedDataMaxMin.countList[1] &&computedDataMaxMin.countList[1].humMax">{{ computedDataMaxMin.countList[1].humMax}}%RH</span>
                        </div>
                      </div>
                      <div class="uk-flex">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_min_temp_hum') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].tempMin">{{formatTempValue( computedDataMaxMin.countList[0].tempMin ) }}{{tempUnit}}</span>
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].tempMin && computedDataMaxMin.countList[0].humMin"> / </span>
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].humMin">{{ computedDataMaxMin.countList[0].humMin}}%RH</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].tempMin">{{ formatTempValue(computedDataMaxMin.countList[1].tempMin ) }}{{tempUnit}}</span>
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].tempMin && computedDataMaxMin.countList[1].humMin"> / </span>
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].humMin">{{ computedDataMaxMin.countList[1].humMin}}%RH</span>
                        </div>
                      </div>
                      <div class="uk-flex uk-flex-between" v-if="exType === 'time'">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_temp') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].tempTimeMax">{{ formatSeconds(computedDataMaxMin.countList[0].tempTimeMax/1000)}}</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].tempTimeMax">{{ formatSeconds(computedDataMaxMin.countList[1].tempTimeMax/1000)}}</span>
                        </div>
                      </div>
                      <div class="uk-flex" v-if="exType === 'time'">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_hum') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[0] && computedDataMaxMin.countList[0].humTimeMax">{{ formatSeconds(computedDataMaxMin.countList[0].humTimeMax/1000)}}</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataMaxMin.countList[1] && computedDataMaxMin.countList[1].humTimeMax">{{ formatSeconds(computedDataMaxMin.countList[1].humTimeMax/1000)}}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="exType === 'time' && computedDataOfflineMax">
                      <div class="uk-flex uk-flex-between">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_offline') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataOfflineMax.countList[0] && computedDataOfflineMax.countList[0].timeMax">{{ formatSeconds(computedDataOfflineMax.countList[0].timeMax/1000)}}</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataOfflineMax.countList[1] && computedDataOfflineMax.countList[1].timeMax">{{ formatSeconds(computedDataOfflineMax.countList[1].timeMax/1000)}}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="exType === 'time' && computedDataPowerMax">
                      <div class="uk-flex uk-flex-between">
                        <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_power') }}</div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataPowerMax.countList[0] && computedDataPowerMax.countList[0].timeMax">{{ formatSeconds(computedDataPowerMax.countList[0].timeMax/1000)}}</span>
                        </div>
                        <div style="width: 180px; box-sizing: border-box;" class="my-td">
                          <span v-if="computedDataPowerMax.countList[1] && computedDataPowerMax.countList[1].timeMax">{{ formatSeconds(computedDataPowerMax.countList[1].timeMax/1000)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- 单个 -->
    <div v-for="(value, key, index) in detailList" :key="key" style="margin:20px 0;" class="border">
      <div class="bg-theme color-white"
       style="width: 100%;text-align:center; height:30px;line-height:30px; margin-bottom: 10px;">
       {{ value.scene.name }}
      </div>
      <div class="uk-flex uk-flex-between pd-10">
        <div class="btns">
          <el-button :type="detailParams[key].type === 1 ? 'primary' : ''"
            :disabled="detailParams[key].dataType !== 1"
            @click="changeDetailType(key, 1)">{{ $t('integration.day') }}</el-button>
          <el-button :type="detailParams[key].type === 2 ? 'primary' : ''" @click="changeDetailType(key, 2)">{{ $t('integration.month') }}</el-button>
          <el-button :type="detailParams[key].type === 3 ? 'primary' : ''" @click="changeDetailType(key, 3)">{{ $t('integration.quarter') }}</el-button>
          <el-button :type="detailParams[key].type === 4 ? 'primary' : ''" @click="changeDetailType(key, 4)">{{ $t('integration.year') }}</el-button>

        </div>
        <div style="flex:1;">
          <!-- 直接统计显示饼图 -->
          <pieEchart v-if="detailParams[key].dataType ===1 && value.data.length" :chartData="setPieEchartDataDetail(key)"/>
          <!-- 同比和环比显示柱状图 -->
          <BarEchart v-if="detailParams[key].dataType !== 1 && detailComputedDataList[key] && detailComputedDataList[key].length"
           :chartData="setBarEchartDataDetail(key)"/>

        </div>
        <div style="width:45%">
          <div class="mb-5">
            <el-radio-group v-model="detailParams[key].dataType" @change="changeDetailDataType(key)">
            <el-radio :label="1">{{ $t('integration.direct_statistics') }}</el-radio>
            <el-radio :label="2"
              :disabled="detailParams[key].type === 1">
              {{ $t('integration.year_on_year') }}{{ $t('integration.data') }}
            </el-radio>
            <el-radio :label="3"
              :disabled="detailParams[key].type === 1">
              {{ $t('integration.month_on_month') }}{{ $t('integration.data') }}
            </el-radio>
          </el-radio-group>
          </div>
          <div class="mb-10">
            <!-- 直接统计时右边table的显示 -->
            <div v-if="detailParams[key].dataType === 1">
              <template v-if="detailParams[key].type === 1">
                <el-date-picker
                  v-model="detailParams[key].timeParams.day"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width:100%;"
                  :clearable="false"
                  @change="changeDetailTime(key)">
                </el-date-picker>
              </template>
              <template v-else-if="detailParams[key].type === 2">
                <el-date-picker
                  v-model="detailParams[key].timeParams.month"
                  type="month"
                  :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                  value-format="yyyy-MM"
                  style="width:100%;"
                  :clearable="false"
                  @change="changeDetailTime(key)">
                </el-date-picker>
              </template>
              <template v-else-if="detailParams[key].type === 3">
                <div>
                  <el-select v-model="detailParams[key].timeParams.quarterYear" style="width:40%;" class="mr-5" @change="changeDetailTime(key)">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="detailParams[key].timeParams.quarter" style="width:55%;" @change="changeDetailTime(key)">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-else>
                <el-select v-model="detailParams[key].timeParams.year" style="width:100%;" @change="changeDetailTime(key)">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </template>
              <div class="border mt-10" style="max-height:100px; overflow: auto;">
                <template v-if="value.data.length">
                  <el-row v-for="(item,index) in value.data" :key="index">
                    <el-col :span="8" class="bd-r">{{ abnormalTypeConvert(item.exCatalog) }}</el-col>
                    <el-col :span="16">{{ exType === 'num' ? item.num : formatSeconds(item.time / 1000)}}</el-col>
                  </el-row>
                  <!-- 异常最高温/湿度和最低温/湿度-->
                  <template v-if="constructMaxMin(value.data).maxMin">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_max_temp_hum') }}</el-col>
                      <el-col :span="16">
                        <span v-if="constructMaxMin(value.data).maxMin.tempMax">{{ formatTempValue(constructMaxMin(value.data).maxMin.tempMax )}}{{tempUnit}}</span>
                        <span v-if="constructMaxMin(value.data).maxMin.tempMax && constructMaxMin(value.data).maxMin.humMax"> / </span>
                        <span v-if="constructMaxMin(value.data).maxMin.humMax">{{ constructMaxMin(value.data).maxMin.humMax}}%RH</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_min_temp_hum') }}</el-col>
                      <el-col :span="16">
                        <span v-if="constructMaxMin(value.data).maxMin.tempMin">{{formatTempValue( constructMaxMin(value.data).maxMin.tempMin )}}{{tempUnit}}</span>
                        <span v-if="constructMaxMin(value.data).maxMin.tempMin && constructMaxMin(value.data).maxMin.humMin"> / </span>
                        <span v-if="constructMaxMin(value.data).maxMin.humMin">{{ constructMaxMin(value.data).maxMin.humMin}}%RH</span>
                      </el-col>
                    </el-row>
                    <!-- 温度/湿度异常持续时间 -->
                    <el-row v-if="exType === 'time'">
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_temp') }}</el-col>
                      <el-col :span="16" v-if="constructMaxMin(value.data).maxMin.tempTimeMax">{{ formatSeconds(constructMaxMin(value.data).maxMin.tempTimeMax / 1000)}}</el-col>
                    </el-row>
                    <el-row v-if="exType === 'time'">
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_hum') }}</el-col>
                      <el-col :span="16" v-if="constructMaxMin(value.data).maxMin.humTimeMax">{{ formatSeconds(constructMaxMin(value.data).maxMin.humTimeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                  <!-- 异常次数里面的离线持续最长时间-->
                  <template v-if="exType === 'time' && constructMaxMin(value.data).offlineMax">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_offline') }}</el-col>
                      <el-col :span="16" v-if="constructMaxMin(value.data).offlineMax.timeMax">{{ formatSeconds(constructMaxMin(value.data).offlineMax.timeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                  <!-- 异常次数里面的断电持续最长时间-->
                  <template v-if="exType === 'time' && constructMaxMin(value.data).powerMax">
                    <el-row>
                      <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_power') }}</el-col>
                      <el-col :span="16" v-if="constructMaxMin(value.data).powerMax.timeMax">{{ formatSeconds(constructMaxMin(value.data).powerMax.timeMax / 1000)}}</el-col>
                    </el-row>
                  </template>
                </template>
                <el-empty v-else :description="$t('public.no_data')" :image-size="50"></el-empty>
              </div>
            </div>
            <div v-else>
              <!-- 同比数据时 -->
              <div v-if="detailParams[key].dataType === 2">
                <!-- 月：同比 -->
                <template v-if="detailParams[key].type === 2">
                  <div>{{$t('integration.statistics')}}
                    <el-date-picker
                      v-model="detailParams[key].timeParams.month"
                      type="month"
                      :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                      value-format="yyyy-MM"
                      style="width:80%;"
                      :clearable="false"
                      @change="changeTimeDetailComputed(key)">
                    </el-date-picker>
                  </div>
                  <div class="mt-5" v-if="detailParams[key].computedParams">{{$t('integration.year_on_year')}}
                    <el-select v-model="detailParams[key].computedParams.computedYear" style="width:70%;" @change="changeTimeDetailComputedYear(key)">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    {{ detailParams[key].computedParams.computedMonth }} {{$t('integration.month')}}
                  </div>
                </template>
                <!-- 季度：同比 -->
                <template v-else-if="detailParams[key].type === 3">
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="detailParams[key].timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeDetailComputed(key)">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                      </el-option>
                    </el-select>
                    <el-select v-model="detailParams[key].timeParams.quarter" style="width:40%;" @change="changeTimeDetailComputed(key)">
                      <el-option
                        v-for="item in quarterList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5" v-if="detailParams[key].computedParams">{{$t('integration.year_on_year')}}
                    <el-select v-model="detailParams[key].computedParams.computedQuarterYear" style="width:30%;" @change="changeTimeDetailComputedYear(key)">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.value === timeParams.quarterYear">
                      </el-option>
                    </el-select>
                    {{ detailParams[key].computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                      ( detailParams[key].computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                      ( detailParams[key].computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                  </div>
                </template>

                <!-- 年：同比 -->
                <template v-else>
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="detailParams[key].timeParams.year" style="width:80%;" @change="changeTimeDetailComputed(key)">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5" v-if="detailParams[key].computedParams">{{$t('integration.year_on_year')}}
                    {{ detailParams[key].computedParams.computedYear }} {{$t('integration.year')}}
                  </div>
                </template>

              </div>

              <!-- 环比数据时 -->
              <div v-else>
                <!-- 月：环比 -->
                <template v-if="detailParams[key].type === 2">
                  <div>{{$t('integration.statistics')}}
                    <el-date-picker
                      v-model="detailParams[key].timeParams.month"
                      type="month"
                      :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                      value-format="yyyy-MM"
                      style="width:80%;"
                      :clearable="false"
                      @change="changeTimeDetailComputed(key)">
                    </el-date-picker>
                  </div>
                  <div class="mt-5" v-if="detailParams[key].computedParams">{{$t('integration.month_on_month')}}
                    {{ detailParams[key].computedParams.computedYear }} {{$t('integration.year')}}
                    {{ detailParams[key].computedParams.computedMonth }} {{$t('integration.month')}}
                  </div>
                </template>
                <!-- 季度：环比 -->
                <template v-else-if="detailParams[key].type === 3">
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="detailParams[key].timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeDetailComputed(key)">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        >
                      </el-option>
                    </el-select>
                    <el-select v-model="detailParams[key].timeParams.quarter" style="width:40%;" @change="changeTimeDetailComputed(key)">
                      <el-option
                        v-for="item in quarterList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ detailParams[key].computedParams.computedQuarterYear }} {{$t('integration.year')}}
                    {{ detailParams[key].computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                      ( detailParams[key].computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                      ( detailParams[key].computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                  </div>
                </template>
                <!-- 年：环比 -->
                  <template v-else>
                    <div>{{$t('integration.statistics')}}
                      <el-select v-model="detailParams[key].timeParams.year" style="width:80%;" @change="changeTimeDetailComputed(key)">
                        <el-option
                          v-for="item in yearList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="mt-5" v-if="detailParams[key].computedParams">{{$t('integration.month_on_month')}}
                      {{ detailParams[key].computedParams.computedYear }} {{$t('integration.year')}}
                    </div>
                  </template>
              </div>

              <div style="height:140px; overflow: auto;">
                <el-table
                  :data="detailComputedDataList[key]"
                  :key="isUpdate"
                  border
                  ref="computedTable"
                  style="margin-top:10px;"
                >
                  <el-table-column
                    :label="$t('public.exception')"
                    >
                    <template  slot-scope="scope">
                      <span>{{ abnormalTypeConvert(scope.row.exCatalog) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index) in detailComputedDynamicColumns[key]"
                    :key="index"
                    width="180"
                  >
                    <template slot="header">
                      <span>{{ item }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="exType === 'num'">
                        <span v-if="!scope.row.countList[index] || !scope.row.countList[index].num"> - </span>
                        <span v-else>
                          {{ scope.row.countList[index].num }}
                        </span>
                      </template>
                      <template v-else>
                        <span v-if="!scope.row.countList[index] || !scope.row.countList[index].time"> - </span>
                        <span v-else>
                          {{ formatSeconds(scope.row.countList[index].time / 1000) }}
                        </span>
                      </template>
                    </template>
                  </el-table-column>

                  <div slot="append">
                      <div v-if="constructMaxMin(detailComputedDataList[key]).maxMin">
                        <div class="uk-flex uk-flex-between">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_max_temp_hum') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMax">{{ formatTempValue(constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMax)}}{{tempUnit}}</span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMax && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMax"> / </span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMax">{{ constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMax}}%RH</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMax">{{formatTempValue( constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMax) }}{{tempUnit}}</span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMax && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMax"> / </span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] &&constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMax">{{ constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMax}}%RH</span>
                          </div>
                        </div>
                        <div class="uk-flex">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_min_temp_hum') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMin">{{ formatTempValue(constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMin) }}{{tempUnit}}</span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempMin && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMin"> / </span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMin">{{ constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humMin}}%RH</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMin">{{ formatTempValue(constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMin) }}{{tempUnit}}</span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempMin && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMin"> / </span>
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMin">{{ constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humMin}}%RH</span>
                          </div>
                        </div>
                        <div class="uk-flex uk-flex-between" v-if="exType === 'time'">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_temp') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempTimeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].tempTimeMax/1000)}}</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempTimeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].tempTimeMax/1000)}}</span>
                          </div>
                        </div>
                        <div class="uk-flex" v-if="exType === 'time'">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_hum') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[0] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humTimeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).maxMin.countList[0].humTimeMax/1000)}}</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).maxMin.countList[1] && constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humTimeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).maxMin.countList[1].humTimeMax/1000)}}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="exType === 'time' && constructMaxMin(detailComputedDataList[key]).offlineMax">
                        <div class="uk-flex uk-flex-between">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_offline') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).offlineMax.countList[0] && constructMaxMin(detailComputedDataList[key]).offlineMax.countList[0].timeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).offlineMax.countList[0].timeMax/1000)}}</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).offlineMax.countList[1] && constructMaxMin(detailComputedDataList[key]).offlineMax.countList[1].timeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).offlineMax.countList[1].timeMax/1000)}}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="exType === 'time' && constructMaxMin(detailComputedDataList[key]).powerMax">
                        <div class="uk-flex uk-flex-between">
                          <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_power') }}</div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).powerMax.countList[0] && constructMaxMin(detailComputedDataList[key]).powerMax.countList[0].timeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).powerMax.countList[0].timeMax/1000)}}</span>
                          </div>
                          <div style="width: 180px; box-sizing: border-box;" class="my-td">
                            <span v-if="constructMaxMin(detailComputedDataList[key]).powerMax.countList[1] && constructMaxMin(detailComputedDataList[key]).powerMax.countList[1].timeMax">{{ formatSeconds(constructMaxMin(detailComputedDataList[key]).powerMax.countList[1].timeMax/1000)}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                </el-table>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>


  </modal>
</template>
<script>
import { getExNumList, getExTimeList, getExNumDetail, getExTimeDetail } from '@/api/modules/overview.js'
import BarEchart from '@/components/echart/barEchart.vue';
import pieEchart from '@/components/echart/pieEchart.vue';
import { formatSeconds } from '@/utils/time';
import { shareUnit } from '../../../../api/modules/public'
import { TempUtils } from '@/utils/TempUtil.js';

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    sceneIds: {
      type: Array,
      default: () => []
    },
    // 是异常次数详情还是异常时间
    exType: {
      type: String,
      default: 'num'
    }
  },
  components: {
    BarEchart,
    pieEchart
  },
  data(){
    return {
      tempUnit:'',
      detailList: {}, // 各个区域的详情组合，键值对形式
      detailParams: {}, // 各个区域单独的请求参数，键值对形式
      detailComputedDataList: {},
      detailComputedDynamicColumns: {},

      overallList: [], // 总体信息的list
      // 选择的数据模式是天/月/季度/年
      type: 1,
      // 选择直接统计/同比/环比
      dataType: 1,
      timeParams: {
        day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
        month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
        year: new Date().getFullYear(),
        quarterYear: new Date().getFullYear(),
        quarter: 1
      },
      computedParams: {},

      computedDynamicColumns: [],

      computedDataList: [],

      isUpdate: false,

      formatSeconds

    }
  },
  computed: {
    title() {
      return this.exType === 'num' ? this.$t('integration.number_of_exceptions') : this.$t('integration.abnormal_time')
    },
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    yearList(){
      let cur = new Date().getFullYear()
      let arr = []
      for(let i=cur; i>cur-5; i--){
        arr.push({
          value: i,
          label: i + this.$t('integration.year')
        })
      }
      return arr
    },
    // 季度
    quarterList(){
      let arr = []
      for(let i=1; i<5; i++){
        let label = ''
        switch (i){
          case 1:
            label = this.$t('integration.one_quarter')
            break
          case 2:
            label = this.$t('integration.two_quarter')
            break
          case 3:
            label = this.$t('integration.three_quarter')
            break
          case 4:
            label = this.$t('integration.four_quarter')
            break
        }
        arr.push({
          value: i,
          label: label
        })
      }
      return arr
    },
    // 有数据异常时才会有异常次数里面的异常最/低高温/湿度
    overallMaxMin(){
      return this.overallList.filter(_ => _.exCatalog === 1)[0]
    },
    // 异常次数里面的离线持续最长时间
    offlineMax(){
      return this.overallList.filter(_ => _.exCatalog === 0)[0]
    },
    // 异常次数里面的断电持续最长时间
    powerMax(){
      return this.overallList.filter(_ => _.exCatalog === 2)[0]
    },
    // 同比/环比时异常时间里面的异常最/低高温/湿度
    computedDataMaxMin(){
      return this.computedDataList.filter(_ => _.exCatalog === 1)[0]
    },
    // 异常次数里面的离线持续最长时间
    computedDataOfflineMax(){
      return this.computedDataList.filter(_ => _.exCatalog === 0)[0]
    },
    // 异常次数里面的断电持续最长时间
    computedDataPowerMax(){
      return this.computedDataList.filter(_ => _.exCatalog === 2)[0]
    },

  },
  created(){
    this.getInitDetail()
    //获取总体信息
    this.getOverallList()
    this.initParams()
    this.UnitMeasurementFn();
  },
  methods: {
    // 构建各个区域的请求参数
    UnitMeasurementFn () {
      shareUnit().then(({ result }) => {
        this.tempUnit = result.find(item => item.code === 'temp')?.name ?? '';
      })
    },
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, this.tempUnit)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    initParams(){
      this.sceneIds.forEach(sceneId => {
        // this.detailParams[sceneId] = {
        //   type: 1,
        //   // 选择直接统计/同比/环比
        //   dataType: 1,
        //   timeParams: {
        //     day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
        //     month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
        //     year: new Date().getFullYear(),
        //     quarterYear: new Date().getFullYear(),
        //     quarter: 1
        //   },
        // }

        this.$set(this.detailParams, sceneId, {
          type: 1,
          // 选择直接统计/同比/环比
          dataType: 1,
          timeParams: {
            day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
            month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
            year: new Date().getFullYear(),
            quarterYear: new Date().getFullYear(),
            quarter: 1
          },
        })
      })
    },

    getInitDetail(){
      let params = {
        scenes: this.sceneIds.join(),
        type: 1,
        time: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate()
      }
      console.log('params=', params, this.timeParams)
      let req = ''
      if(this.exType === 'num'){
        req = getExNumDetail(params)
      }else{
        req = getExTimeDetail(params)

      }
      req.then(res => {
        if (res.state.code === 200) {
          res.result.forEach(item => {
            this.$set( this.detailList, item.scene.id, item)
          })
          console.log(' this.detailList=',  this.detailList)
        }
      })

    },
    //获取总体信息
    getOverallList(){
      return new Promise((resolve, reject) => {
        let params = {
          scenes: this.sceneIds.join(),
          type: this.type
        }
        if(this.type === 1){
          params.time = this.timeParams.day
        }else if(this.type === 2){
          params.time = this.timeParams.month
        }else if(this.type === 3){
          params.time = this.timeParams.quarterYear + '-' + this.timeParams.quarter
        }else{
          params.time = this.timeParams.year
        }
        console.log('params=', params, this.timeParams)
        let req = ''
        if(this.exType === 'num'){
          req = getExNumList(params)
        }else{
          req = getExTimeList(params)
        }
        req.then(res => {
          if (res.state.code === 200) {
            this.overallList = res.result
            resolve();
          }
        })
      })
    },

    // 选择的数据模式改变
    changeType(type){
      this.type = type
      if(this.dataType === 1){
        this.getOverallList()
      }else{
        this.changeDataType()
      }
    },
    changeTime(){
      this.getOverallList()
    },
    // 直接统计/同比/环比改变
    async changeDataType(){
      if(this.dataType == 2 ){
        this.computedParams = JSON.parse(JSON.stringify(this.timeParams))

        if(this.type ===2){
          this.$set(this.computedParams, 'computedYear', parseInt(this.computedParams.month.split('-')[0]) - 1)
          this.$set(this.computedParams, 'computedMonth', this.computedParams.month.split('-')[1])
        }else if(this.type === 3){
          this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear - 1)
          this.$set(this.computedParams, 'computedQuarter', this.computedParams.quarter)
        }else{
          this.$set(this.computedParams, 'computedYear', this.computedParams.year - 1)
        }

      }else if(this.dataType == 3){
        this.computedParams = JSON.parse(JSON.stringify(this.timeParams))
        if(this.type ===2){
          // 如果是1月环比，就要和上一年的12月比
          if(parseInt(this.computedParams.month.split('-')[1]) ===  1){
            this.$set(this.computedParams, 'computedYear', parseInt(this.computedParams.month.split('-')[0]) - 1)
            this.$set(this.computedParams, 'computedMonth', 12)
          }else{
            this.$set(this.computedParams, 'computedYear', this.computedParams.month.split('-')[0])
            this.$set(this.computedParams, 'computedMonth', parseInt(this.computedParams.month.split('-')[1]) - 1)
          }

        }else if(this.type === 3){
          // 如果是第一季度环比，就是和上一年的第4季度比
          if(this.computedParams.quarter == 1){
            this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear - 1)
            this.$set(this.computedParams, 'computedQuarter', 4)
          }else{
            this.$set(this.computedParams, 'computedQuarterYear', this.computedParams.quarterYear)
            this.$set(this.computedParams, 'computedQuarter', this.computedParams.quarter - 1)
          }

        }else{
          this.$set(this.computedParams, 'computedYear', this.computedParams.year - 1)
        }
      }
      await this.getOverallList()
      this.getComputedEx()
    },
    // 获取对比的另一个数据
    getComputedEx(){
      this.computedDynamicColumns = []
      this.computedDataList = []
        let params = {
          scenes: this.sceneIds.join(),
          type: this.type
        }
        if(this.type === 2){
          params.time = this.computedParams.computedYear + '-' + this.computedParams.computedMonth

          this.computedDynamicColumns.push(`${this.timeParams.month.split('-')[0]}${this.$t('integration.year')}${this.timeParams.month.split('-')[1]}${this.$t('integration.month')}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedYear}${this.$t('integration.year')}${this.computedParams.computedMonth}${this.$t('integration.month')}`)

        }else if(this.type === 3){
          params.time = this.computedParams.computedQuarterYear + '-' + this.computedParams.computedQuarter

          let label1 = ''
          switch (this.timeParams.quarter){
            case 1:
              label1 = this.$t('integration.one_quarter')
              break
            case 2:
              label1 = this.$t('integration.two_quarter')
              break
            case 3:
              label1 = this.$t('integration.three_quarter')
              break
            case 4:
              label1 = this.$t('integration.four_quarter')
              break
          }
          let label2 = ''
          switch (this.computedParams.computedQuarter){
            case 1:
              label2 = this.$t('integration.one_quarter')
              break
            case 2:
              label2 = this.$t('integration.two_quarter')
              break
            case 3:
              label2 = this.$t('integration.three_quarter')
              break
            case 4:
              label2 = this.$t('integration.four_quarter')
              break
          }

          this.computedDynamicColumns.push(`${this.timeParams.quarterYear}${this.$t('integration.year')} ${label1}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedQuarterYear}${this.$t('integration.year')} ${label2}`)

        }else{
          params.time = this.computedParams.computedYear

           this.computedDynamicColumns.push(`${this.timeParams.year}${this.$t('integration.year')}`)
          this.computedDynamicColumns.push(`${this.computedParams.computedYear}${this.$t('integration.year')}`)
        }
        console.log('params=', params, this.computedParams)
        console.log('computedDynamicColumns=================', this.computedDynamicColumns)
          // this.$refs.computedTable.doLayout()
        this.isUpdate = !this.isUpdate

        let req = ''
        if(this.exType === 'num'){
          req = getExNumList(params)
        }else{
          req = getExTimeList(params)
        }
        req.then(res => {
          if (res.state.code === 200) {
            // 整合对比的两个table数据
            if(this.overallList.length){
              this.overallList.forEach(item => {
                this.computedDataList.push({
                  exCatalog: item.exCatalog,
                  countList: [{...item}]
                })
              })

              res.result.forEach(item2 => {
                let index = this.computedDataList.findIndex(_ => _.alarmReason === item2.alarmReason)
                if(index === -1){
                  this.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
                }else{
                  this.computedDataList[index].countList.push({...item2})
                }

              })
            }else{
              res.result.forEach(item2 => {
                this.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
              })
            }


            console.log('computedDataList=',this.computedDataList)

          }
        })
    },

    // 同比时第一行统计选择改变时
    changeTimeComputed(){
      this.changeDataType()
    },

    // 同比时第二行选择改变时
    async changeTimeComputedYear(){
      console.log('changeTimeComputedYear=================', this.computedParams.computedYear)
       await this.getOverallList()
        this.getComputedEx()
    },

    // 单个改变数据模式时请求对应的详情
    getDetailSingle(key){
      return new Promise((resolve, reject) => {
        let params = {
          scenes: key,
          type: this.detailParams[key].type
        }
        if(this.detailParams[key].type === 1){
          params.time = this.detailParams[key].timeParams.day
        }else if(this.detailParams[key].type === 2){
          params.time = this.detailParams[key].timeParams.month
        }else if(this.detailParams[key].type === 3){
          params.time = this.detailParams[key].timeParams.quarterYear + '-' + this.detailParams[key].timeParams.quarter
        }else{
          params.time = this.detailParams[key].timeParams.year
        }
        console.log('params=', params, this.detailParams[key])
        let req = ''
        if(this.exType === 'num'){
          req = getExNumList(params)
        }else{
          req = getExTimeList(params)
        }
        req.then(res => {
          if (res.state.code === 200) {
            this.detailList[key].data = res.result
            resolve()
          }
        })
      })
    },

    setPieEchartData(){
      // 整理构造饼图数据
      let pieSeries = []

      this.overallList.forEach(item => {
        pieSeries.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: this.exType === 'num' ? item.num : item.time
          })
      })
      let tooltip = {}
      if(this.exType === 'time'){
        tooltip = {
          formatter: params => {
            return (
              params.name + ": " + this.formatSeconds(params.value / 1000)
            )
          }
        }
      }
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        tooltip
      }
    },

    // 整理柱状图数据
    setBarEchartDataOverall(){
      let data = []
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data = this.computedDataList
      barSeries.xAxis = this.computedDynamicColumns
      data.forEach(item => {
        let arr = []
        if(this.exType === 'num'){
           arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[0] ? item.countList[0].num : 0
          })
          arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[1] ? item.countList[1].num: 0
          })
        }else{
          arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[0] ? item.countList[0].time : 0
          })
          arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[1] ? item.countList[1].time: 0
          })
        }
        barSeries.series.push(arr)
      })
      console.log('barSeries=', barSeries)

      let tooltip = {}
      if(this.exType === 'num'){
        tooltip = {
          formatter: params => {
            return (
              params.data.name + ": " + params.data.value
            )
          }
        }
      }else{
        tooltip = {
          formatter: params => {
            return (
              params.data.name + ": " + this.formatSeconds(params.data.value / 1000)
            )
          }
        }
      }

      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        tooltip
      }
    },

    changeDetailType(key, type){
      console.log('key=',key)
      console.log('this.detailParams=',this.detailParams)
      this.detailParams[key].type = type
      if(this.detailParams[key].dataType === 1){
        this.getDetailSingle(key)
      }else{
        this.changeDetailDataType(key)
      }
    },
    changeDetailTime(key){
      this.getDetailSingle(key)
    },
    async changeDetailDataType(key){
      if(this.detailParams[key].dataType == 2 ){
        this.$set(this.detailParams[key], 'computedParams', JSON.parse(JSON.stringify(this.detailParams[key].timeParams)))
        // this.computedParams = JSON.parse(JSON.stringify(this.timeParams))

        if(this.detailParams[key].type ===2){
          this.$set(this.detailParams[key].computedParams, 'computedYear', parseInt(this.detailParams[key].computedParams.month.split('-')[0]) - 1)
          this.$set(this.detailParams[key].computedParams, 'computedMonth', this.detailParams[key].computedParams.month.split('-')[1])
        }else if(this.detailParams[key].type === 3){
          this.$set(this.detailParams[key].computedParams, 'computedQuarterYear', this.detailParams[key].computedParams.quarterYear - 1)
          this.$set(this.detailParams[key].computedParams, 'computedQuarter', this.detailParams[key].computedParams.quarter)
        }else{
          this.$set(this.detailParams[key].computedParams, 'computedYear', this.detailParams[key].computedParams.year - 1)
        }

      }else if(this.detailParams[key].dataType == 3){
        this.$set(this.detailParams[key], 'computedParams', JSON.parse(JSON.stringify(this.detailParams[key].timeParams)))

        if(this.detailParams[key].type ===2){
          // 如果是1月环比，就要和上一年的12月比
          if(parseInt(this.detailParams[key].computedParams.month.split('-')[1]) ===  1){
            this.$set(this.detailParams[key].computedParams, 'computedYear', parseInt(this.detailParams[key].computedParams.month.split('-')[0]) - 1)
            this.$set(this.detailParams[key].computedParams, 'computedMonth', 12)
          }else{
            this.$set(this.detailParams[key].computedParams, 'computedYear', this.detailParams[key].computedParams.month.split('-')[0])
            this.$set(this.detailParams[key].computedParams, 'computedMonth', parseInt(this.detailParams[key].computedParams.month.split('-')[1]) - 1)
          }

        }else if(this.detailParams[key].type === 3){
          // 如果是第一季度环比，就是和上一年的第4季度比
          if(this.detailParams[key].computedParams.quarter == 1){
            this.$set(this.detailParams[key].computedParams, 'computedQuarterYear', this.detailParams[key].computedParams.quarterYear - 1)
            this.$set(this.detailParams[key].computedParams, 'computedQuarter', 4)
          }else{
            this.$set(this.detailParams[key].computedParams, 'computedQuarterYear', this.detailParams[key].computedParams.quarterYear)
            this.$set(this.detailParams[key].computedParams, 'computedQuarter', this.detailParams[key].computedParams.quarter - 1)
          }

        }else{
          this.$set(this.detailParams[key].computedParams, 'computedYear', this.detailParams[key].computedParams.year - 1)
        }
      }
      console.log(this.detailParams[key])
      await this.getDetailSingle(key)
      this.getDetailComputedAlarm(key)
    },
    getDetailComputedAlarm(key){
      // this.detailComputedDynamicColumns[key] = []
      // this.detailComputedDataList[key] = []
      this.$set(this.detailComputedDynamicColumns, key, [])
      this.$set(this.detailComputedDataList, key, [])

        let params = {
          scenes: key,
          type: this.detailParams[key].type
        }
        if(this.detailParams[key].type === 2){
          params.time = this.detailParams[key].computedParams.computedYear + '-' + this.detailParams[key].computedParams.computedMonth

          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].timeParams.month.split('-')[0]}${this.$t('integration.year')}${this.detailParams[key].timeParams.month.split('-')[1]}${this.$t('integration.month')}`)
          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].computedParams.computedYear}${this.$t('integration.year')}${this.detailParams[key].computedParams.computedMonth}${this.$t('integration.month')}`)

        }else if(this.detailParams[key].type === 3){
          params.time = this.detailParams[key].computedParams.computedQuarterYear + '-' + this.detailParams[key].computedParams.computedQuarter

           let label1 = ''
          switch (this.detailParams[key].timeParams.quarter){
            case 1:
              label1 = this.$t('integration.one_quarter')
              break
            case 2:
              label1 = this.$t('integration.two_quarter')
              break
            case 3:
              label1 = this.$t('integration.three_quarter')
              break
            case 4:
              label1 = this.$t('integration.four_quarter')
              break
          }
          let label2 = ''
          switch (this.detailParams[key].computedParams.computedQuarter){
            case 1:
              label2 = this.$t('integration.one_quarter')
              break
            case 2:
              label2 = this.$t('integration.two_quarter')
              break
            case 3:
              label2 = this.$t('integration.three_quarter')
              break
            case 4:
              label2 = this.$t('integration.four_quarter')
              break
          }

          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].timeParams.quarterYear}${this.$t('integration.year')} ${label1}`)
          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].computedParams.computedQuarterYear}${this.$t('integration.year')} ${label2}`)

        }else{
          params.time = this.detailParams[key].computedParams.computedYear

          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].timeParams.year}${this.$t('integration.year')}`)
          this.detailComputedDynamicColumns[key].push(`${this.detailParams[key].computedParams.computedYear}${this.$t('integration.year')}`)
        }
        console.log('params=', params, this.detailParams[key].computedParams)
        console.log('detailComputedDynamicColumns[key]=================', this.detailComputedDynamicColumns[key])
          // this.$refs.computedTable.doLayout()
        this.isUpdate = !this.isUpdate

        let req = ''
        if(this.exType === 'num'){
          req = getExNumList(params)
        }else{
          req = getExTimeList(params)
        }
        req.then(res => {
          if (res.state.code === 200) {
            // 整合对比的两个table数据
            if(this.detailList[key].data.length){
              this.detailList[key].data.forEach(item => {
                this.detailComputedDataList[key].push({
                  exCatalog: item.exCatalog,
                  countList: [{...item}]
                })
              })

              res.result.forEach(item2 => {
                let index = this.detailComputedDataList[key].findIndex(_ => _.alarmReason === item2.alarmReason)
                if(index === -1){
                  this.detailComputedDataList[key].push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
                }else{
                  this.detailComputedDataList[key][index].countList.push({...item2})
                }

              })
            }else{
              res.result.forEach(item2 => {
                this.detailComputedDataList[key].push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
              })
            }


            console.log('detailComputedDataList[key]=',this.detailComputedDataList[key])

          }
        })
    },
    changeTimeDetailComputed(key){
      this.changeDetailDataType(key)
    },
    async changeTimeDetailComputedYear(key){
      await this.getDetailSingle(key)
      this.getDetailComputedAlarm(key)
    },
    setPieEchartDataDetail(key){
      // 整理构造饼图数据
      let pieSeries = []
      let data = this.detailList[key].data

      data.forEach(item => {
        pieSeries.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: this.exType === 'num' ? item.num : item.time
          })
      })
      let tooltip = {}
      if(this.exType === 'time'){
        tooltip = {
          formatter: params => {
            return (
              params.name + ": " + this.formatSeconds(params.value / 1000)
            )
          }
        }
      }
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        tooltip
      }
    },
    // 整理柱状图数据
    setBarEchartDataDetail(key){
      let data = []
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data = this.detailComputedDataList[key]
      barSeries.xAxis = this.detailComputedDynamicColumns[key]
      data.forEach(item => {
        let arr = []
        if(this.exType === 'num'){
           arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[0] ? item.countList[0].num : 0
          })
          arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[1] ? item.countList[1].num: 0
          })
        }else{
           arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[0] ? item.countList[0].time : 0
          })
          arr.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.countList[1] ? item.countList[1].time: 0
          })
        }

        barSeries.series.push(arr)
      })
      console.log('barSeries=', barSeries)
      let tooltip = {}
      if(this.exType === 'num'){
        tooltip = {
          formatter: params => {
            return (
              params.data.name + ": " + params.data.value
            )
          }
        }
      }else{
        tooltip = {
          formatter: params => {
            return (
              params.data.name + ": " + this.formatSeconds(params.data.value / 1000)
            )
          }
        }
      }
      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        tooltip
      }
    },

    // 计算单个的异常高温/低湿度持续时间等，方便页面使用
    constructMaxMin(data){
      return {
        maxMin: data.filter(_ => _.exCatalog === 1)[0],
        offlineMax: data.filter(_ => _.exCatalog === 0)[0],
        powerMax: data.filter(_ => _.exCatalog === 2)[0]
      }
    },

    abnormalTypeConvert(type){
      switch(type){
        case 0:
          return this.$t('public.ex_conn')
        case 1:
          return this.$t('public.ex_data')
        case 2:
          return this.$t('public.ex_power')
        case 3:
          return this.$t('public.ex_max_temp_hum')
        case 4:
          return this.$t('public.ex_min_temp_hum')
        case 5:
          return this.$t('public.ex_duration_temp')
        case 6:
          return this.$t('public.ex_duration_hum')
        case 7:
          return this.$t('public.ex_duration_offline')
        case 8:
          return this.$t('public.ex_duration_power')
      }
    },
    close(){
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.btns{
  width: 100px;
  .el-button{
    width: 80px;
    margin: 5px;
  }
}
.echarts {
  // width: 50% !important;
  height: 220px !important;
}

.el-row {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #CCCCCC;
  text-align: center;
}
.mt-10{
  margin-top: 10px;
}
.my-td{
    border-right: 1px solid #dfe6ec;
    padding: 0 10px;
    height: 27px;
    line-height: 27px;
}
</style>
